import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import { translate } from '../../../../shared/translations';
import Dropdown from '../../../../shared/components/Dropdown/Dropdown';
import Button from '../../../../shared/components/Button/Button';
import { getIdentityProviders } from '../../../../selectors/login';
import { ssoLoginAction } from '../../../../actions/actionCreators';
import { Paragraph, Paragraph2, Subhead1 } from '../../../../shared/theme/styles';

export const SSOForm = ({ setSSO }) => {
    const dispatch = useDispatch();
    const identityProviders = useSelector(getIdentityProviders);
    const [selectedIdentityProvider, setSelectedIdentityProvider] = useState(identityProviders[0]);

    const dropdownOptions = identityProviders.map((provider) => ({
        key: provider,
        text: provider,
        onClick: () => {
            setSelectedIdentityProvider(provider);
            document.body.click();
        },
    }));

    const onFormSubmit = (event) => {
        event.preventDefault();
        dispatch(ssoLoginAction(selectedIdentityProvider));
    };

    return (
        <div className="loginFormPanel ssoFormPanel">
            <Form id="ssoLoginForm" onSubmit={onFormSubmit}>
                <div className="loginFormLabel" style={Subhead1}>
                    SSO
                </div>
                <div className="loginFormLabel" style={Paragraph2}>
                    {translate('single_sign_on_allows_you_to_log_in')}
                </div>
                <Form.Group>
                    <Dropdown
                        id="providerDropdown"
                        testId="providerDropdown"
                        dropdownType="dropdownAction"
                        dropdownButtonStyle="secondary"
                        iconType="chevron"
                        text={selectedIdentityProvider}
                        options={dropdownOptions}
                    />
                </Form.Group>
                <div className="loginFormButtonGroup">
                    <div
                        id="cancelSSOButton"
                        className="hyperlink-label useSSOBtn"
                        style={Paragraph}
                        role="button"
                        tabIndex={0}
                        onClick={() => setSSO(false)}
                    >
                        {translate('cancel')}
                    </div>
                    <Button
                        id="ssoSubmitButton"
                        variant="primary"
                        type="submit"
                        content={translate('submit')}
                    />
                </div>
            </Form>
        </div>
    );
};

export default SSOForm;
